const MenuList = [
  {
    href: "/",
    text: "Home",
  },
  {
    href: "/servicios",
    text: "Services",
  },
  {
    href: "/quienes-somos",
    text: "About Us",
  },
  /*   {
      href: "/casos-de-exito",
      text: "Success Stories",
    }, */
  {
    href: "https://vfgconsulting.peopleforce.io/careers",
    text: "Join Us",
    external: true,
  },
  {
    href: "/contacto",
    text: "Contact",
  },
];

export default MenuList;
